<template>
  <ucar-mask :supportTouchmove="supportTouchmove">
    <div class="dialog-wrapper" :class="{'has-close': needClose}">
      <div class="dialog-close" v-if="needClose" @click="close"></div>
      <div class="dialog-content">
        <slot></slot>
      </div>
      <div class="dialog-footer">
        <div class="dialog-button" :class="{'disabled': disabled}" v-for="(item, index) in btnList" :key="item" @click="handle(index)">
          {{item}}
        </div>
      </div>
    </div>
  </ucar-mask>  
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    needClose: {
      type: Boolean,
      default: false
    },
    btnList: {
      type: Array,
      default: () => []
    },
    supportTouchmove: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handle (index) {
      this.$emit('btn-click', index)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../styles/variable.styl';

.dialog-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  background-color: #fff;
  border-radius: 10px;
  width: 690px;
  display: flex;
  padding-top: 30px;
  flex-flow: column nowrap;

  &.has-close {
    padding-top: 90px;
  }

  .dialog-close {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 30px;
    height: 30px;
    overflow: hidden;

    &::before, &::after {
      content: '';
      position: absolute;
      background-color: $ucar_light_border;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 3px;
      height: 45px;
    }

    &::before {
      transform: translate3d(-50%, -50%, 0) rotate(45deg);
    }

    &::after {
      transform: translate3d(-50%, -50%, 0) rotate(-45deg);
    }
  }

  .dialog-content {
    max-height: 900px;
    overflow: auto;
    padding: 30px 30px 30px;
    -webkit-overflow-scrolling: touch;
  }

  .dialog-footer {
    border-top: 1PX solid $ucar_light_border;

    .dialog-button {
      height: 90px;
      line-height: 90px;
      font-size: $ucar_font_h4;
      color: $ucar_font_assist_color;
      text-align: center;

      &:first-child {
        color: $ucar_main_button;
      }

      &.disabled {
        color: $ucar_font_assist_color;
        pointer-events: none;
      }
    }

    .dialog-button + .dialog-button {
      border-top: 1PX solid $ucar_light_border;
    }
  }
}
</style>
